// DialogPhaseSetting Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import { PHASE_TYPES } from '../../../../shared/constants.js'

class DialogSetting extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }

    this.data = {
      projectTitle: '',
      contactName: '',
      phase: null
    }
    this._references = {
      confirmDelete: React.createRef()
    }
  }

  static get propTypes () {
    return {
      showdelete: PropTypes.bool,
      deleteMessage: PropTypes.string,
      onDelete: PropTypes.func,
      onCopy: PropTypes.func,
      phase: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      showdelete: true,
      deleteMessage: '',
      onDelete: null,
      onCopy: null,
      phase: {}
    }
  }

  show (projectTitle, contactName, phase) {
    this.data.projectTitle = projectTitle
    this.data.contactName = contactName
    this.data.phase = phase
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    this.data.projectTitle = ''
    this.data.contactName = ''
    this.data.phase = null
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  render () {
    const { projectTitle, contactName, phase } = this.data
    let title
    let status = ''
    if (phase) {
      title = phase.title
      status = phase.status
    }

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal
        className='dialog-phasesetting'
      >
        <div className='dialog-actionboard'>
          <div className='actionboard-section'>
            <div className='actionboard-row'>
              <div className='actionboard-col'>
                <div className='msg'>{title}</div>
                <div className='title'>{contactName}</div>
                {contactName && <div className='split' />}
                <div className='title'>{projectTitle}</div>
                {projectTitle && status && <div className='split' />}
                <div className='title alt'>{status}</div>
              </div>
            </div>
          </div>
          <div className='actionboard-footer'>
            <div className='actionboard-row act-row'>
              {this._renderActions()}
            </div>

            <ConfirmDelete
              ref={this._references.confirmDelete}
              title={this.props.deleteMessage}
              onClickOk={this._onClickDeleteConfirm.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  _renderActions () {
    const actions = this._getActions()

    return actions.map((action, idx) => {
      /* eslint-disable react/jsx-handler-names */
      return (
        <div className='actionboard-col2 alert-col2' key={idx}>
          <div className='action-btn' onClick={action.handler}>
            <Button
              icon={action.icon}
              className={action.className}
              canHover={false}
            />
            <span className='label'>
              <IntlMessage ident={action.title} />
            </span>
          </div>
        </div>
      )
      /* eslint-enable react/jsx-handler-names */
    })
  }

  _getActions () {
    const { showdelete, phase } = this.props
    const actions = []

    if (showdelete) {
      actions.push({
        title: 'project.viewBudget.actionPhaseDelete',
        icon: 'action-delete',
        handler: this._onDelete.bind(this),
        className: 'button_dialog button_dialogdlt'
      })
    }

    if (phase.type === PHASE_TYPES.DISCOUNT) {
      return actions
    }

    actions.push({
      title: 'project.viewBudget.actionPhaseCopy',
      icon: 'action-copy',
      handler: this._onCopy.bind(this),
      className: 'button_dialog'
    })

    return actions
  }

  _onClickDeleteConfirm (ev) {
    ev.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(ev)
    }
  }

  _onCopy (ev) {
    ev.preventDefault()

    if (this.props.onCopy) {
      this.props.onCopy(ev)
    }
  }

  _onDelete (ev) {
    ev.preventDefault()

    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }
}

export default DialogSetting
